import { Box, Flex, Text, Icon, Button } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Card from "components/card/Card";

import { GetFacilityDetails } from "utils/facilities";
import { LocationFacilities } from "utils/facilities";
import useAxios from "axios-hooks";
import { useSetRecoilState } from "recoil";
import { toastState } from "atoms/toastState";

const Facilities = (props) => {
  const [initFac, setInitFac] = useState([]);
  const [availableFacilities, setAvailableFacilities] = useState([]);
  const [unavailableFacilities, setUnavailableFacilities] =
    useState(LocationFacilities);
  const setToast = useSetRecoilState(toastState);
  const [{ data, loading, error }, execute] = useAxios(
    {
      url: "/api/locations/update/" + props?.data?.Id,
      method: "GET",
    },
    { manual: true }
  );

  // Function to move a facility from unavailable to available
  const AvailabilityHandler = (facility) => {
    //sort arrays each time
    const availableArray = [...availableFacilities, facility];
    //sort available array
    availableArray.sort((a, b) => a.localeCompare(b));
    setAvailableFacilities(availableArray);

    //sort unavailable array
    const unavailableArray = unavailableFacilities.filter(
      (f) => f !== facility
    );
    //sort unavailable array
    unavailableArray.sort((a, b) => a.localeCompare(b));
    setUnavailableFacilities(unavailableArray);
  };

  // Function to move a facility from available to unavailable
  const UnavailabilityHandler = (facility) => {
    //sort arrays each time
    const availableArray = availableFacilities.filter((f) => f !== facility);
    //sort available array
    availableArray.sort((a, b) => a.localeCompare(b));
    setAvailableFacilities(availableArray);

    //sort unavailable array
    const unavailableArray = [...unavailableFacilities, facility];
    //sort unavailable array
    unavailableArray.sort((a, b) => a.localeCompare(b));
    setUnavailableFacilities(unavailableArray);
  };

  const handleSave = async () => {
    try {
      let facToBeAdded = [];
      let facToBeRemoved = [];
      let body = {};
      facToBeAdded = availableFacilities.filter((f) => !initFac.includes(f));
      facToBeRemoved = initFac.filter((f) => !availableFacilities.includes(f));
      body["FacilitiesToBeAdded"] = facToBeAdded;
      body["FacilitiesToBeRemoved"] = facToBeRemoved;
      if (facToBeAdded.length > 0 || facToBeRemoved.length > 0) {
        await execute({
          url: "/api/locations/update/" + props?.data?.Id,
          method: "PATCH",
          data: body,
        });
        setToast({
          isOpen: true,
          title: "Successfully updated facilities",
          status: "success",
        });
        props?.getStation();
      } else {
        setToast({
          isOpen: true,
          title: "Nothing new to update",
          status: "warning",
          position: "top",
        });
      }
    } catch (error) {
      const err = error?.response?.data?.error;
      setToast({
        isOpen: true,
        title: "Error occured when updating facilities",
        description: err ? err : null,
        status: "error",
      });
    }
  };

  const getFacilityIcon = (facilityName) => {
    return GetFacilityDetails(facilityName).icon;
  };

  const getFacilityText = (facilityName) => {
    return GetFacilityDetails(facilityName).text;
  };

  useEffect(() => {
    if (props?.data?.Facilities) {
      //sort initialFacilities
      setInitFac(props.data.Facilities);
      LocationFacilities.sort((a, b) => a.localeCompare(b));
      setAvailableFacilities(props.data.Facilities);
      setUnavailableFacilities(
        LocationFacilities.filter((f) => !props.data.Facilities.includes(f))
      );
    }
  }, [props?.data]);

  return (
    <Box w="100%" px={{ base: "8px", sm: "12px", md: "20px" }}>
      <Flex direction="column" gap={{ base: "16px", md: "30px" }} justifyContent="center">
        {/* First Container: Available Facilities */}
        <Card w="100%" px={{ base: "12px", md: "20px" }}>
          <Box py={{ base: "8px", md: "2px" }}>
            <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }} mb={{ base: 2, md: 4 }}>
              Note: Please click the below facilities to remove them from your
              station.
            </Text>
            {availableFacilities.length === 0 ? (
              <Text color="gray.500" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                No facilities available
              </Text>
            ) : (
              <Flex minChildWidth={{ base: "80px", sm: "105px" }} gap={{ base: "8px", md: "5px" }} wrap="wrap" justifyContent={{ base: "center", sm: "flex-start" }}>
                {availableFacilities.map((facility) => (
                  <Box
                    key={facility.id}
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    width={{ base: "80px", sm: "100px" }}
                    height={{ base: "80px", sm: "100px" }}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    p={{ base: 1, md: 2 }}
                    cursor="pointer"
                    backgroundColor="white"
                    _hover={{
                      backgroundColor: "black",
                      "& > svg": { color: "white" },
                      "& > p": { color: "white" },
                    }}
                    onClick={() => UnavailabilityHandler(facility)}
                  >
                    <Icon
                      as={getFacilityIcon(facility)}
                      boxSize={{ base: 4, md: 5 }}
                      mb={{ base: 0.5, md: 1 }}
                      color="gray.800"
                    />
                    <Text fontSize={{ base: "2xs", sm: "xs" }} color="gray.800" textAlign="center">
                      {getFacilityText(facility)}
                    </Text>
                  </Box>
                ))}
              </Flex>
            )}
          </Box>
          <Flex justifyContent={{ base: "center", md: "end" }} mt={{ base: 3, md: 4 }}>
            <Button
              bgColor="#f57d36"
              color="white"
              variant="solid"
              _hover={{ bgColor: "#d44e00" }}
              borderRadius={8}
              onClick={handleSave}
              isLoading={loading}
              w={{ base: "full", sm: "auto" }}
              px={{ base: 6, md: 8 }}
              fontSize={{ base: "sm", md: "md" }}
            >
              Save
            </Button>
          </Flex>
        </Card>

        {/* Second Container: Unavailable Facilities */}
        <Card w="100%" px={{ base: "12px", md: "20px" }}>
          <Box py={{ base: "12px", md: "20px" }}>
            <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }} mb={{ base: 2, md: 4 }}>
              Note: Please click the below facilities to add them to your
              station.
            </Text>
            {unavailableFacilities.length === 0 ? (
              <Text color="gray.500" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                All facilities are available
              </Text>
            ) : (
              <Flex minChildWidth={{ base: "80px", sm: "105px" }} gap={{ base: "8px", md: "5px" }} wrap="wrap" justifyContent={{ base: "center", sm: "flex-start" }}>
                {unavailableFacilities.map((facility) => (
                  <Box
                    key={facility.id}
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    width={{ base: "80px", sm: "100px" }}
                    height={{ base: "80px", sm: "100px" }}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    p={{ base: 1, md: 2 }}
                    cursor="pointer"
                    _hover={{
                      backgroundColor: "black",
                      "& > svg": { color: "white" },
                      "& > p": { color: "white" },
                    }}
                    onClick={() => AvailabilityHandler(facility)}
                  >
                    <Icon
                      as={getFacilityIcon(facility)}
                      boxSize={{ base: 4, md: 5 }}
                      mb={{ base: 0.5, md: 1 }}
                      color="gray.900"
                    />
                    <Text fontSize={{ base: "2xs", sm: "xs" }} color="gray.900" textAlign="center">
                      {getFacilityText(facility)}
                    </Text>
                  </Box>
                ))}
              </Flex>
            )}
          </Box>
        </Card>
      </Flex>
    </Box>
  );
};

export default Facilities;
